import React from 'react';
import cn from 'classnames';
import { ErrorModal } from './ErrorModal';
import { DowntimeModal } from './DowntimeModal';

export interface ActionButtonConfig {
  href?: string;
  title?: string;
  isVisible?: boolean;
}

interface ErrorProps {
  title?: string;
  message: string;
  isVisible?: boolean;
  isDismissable?: boolean;
  isDowntime?: boolean;
  onDismiss?: () => void;
  actionButton: ActionButtonConfig;
}

function Error({
  title = 'Unknown Error',
  message,
  isVisible = true,
  isDismissable = false,
  isDowntime,
  onDismiss = () => {},
  actionButton,
}: ErrorProps) {
  return (
    <div className={cn('as-Error', { 'is-visible': isVisible })}>
      {isDowntime ? (
        <DowntimeModal
          message={message}
          title={title}
          actionButton={actionButton}
        />
      ) : (
        <ErrorModal
          title={title}
          message={message}
          isDismissable={isDismissable}
          onDismiss={onDismiss}
          actionButton={actionButton}
        />
      )}
    </div>
  );
}

export default Error;
